import jwt_decode from 'jwt-decode';

// utility functions
export default {
  parseJwt(jwt) {
    return jwt_decode(jwt);
  },
  isEncoded(uri) {
    uri = uri || '';

    return uri !== decodeURIComponent(uri);
  },
  encodeUriComponent(uri) {
    if (this.isEncoded(uri)) {
      return uri;
    }

    return encodeURIComponent(uri);
  },
  decodeUriComponent(uri) {
    if (this.isEncoded(uri)) {
      return decodeURIComponent(uri);
    }

    return uri;
  }
}
